// api.js
const apiUrl = '';


export default apiUrl;
